<template>
   <div class="nodes-container">
      <div class="label">Nodes</div>
      <ul class="nodes">
         <li v-for="(node, index) in nodes" :key="index" :class="nodeLinkClasses(node)" v-on:click="selectDisplayNode(node)">{{node}}</li>
      </ul>
   </div>
</template>

<script>
export default {
   name:"ListNodes",
   props:["nodes","currentNodes","chartIndex"],
   methods: {
      selectDisplayNode: function(node) {
         this.$emit("node", {"chartIndex":this.chartIndex,"node":node});
      },
      nodeLinkClasses: function(node) {
         let classes = ['pds-node'];
         //if(node == this.currentNode) classes.push('active');
         console.log(this.currentNodes);
         if(this.currentNodes.includes(node)) classes.push('active');
         return classes;
      }
   }
}
</script>

<style lang="scss">
.nodes-container {
   padding-top: 1em;
   .label {
      font-weight: bold;
      text-transform: uppercase;
      color: #000;
      margin-top: 0.5em;
      text-align: left;
      display: block;
   }
}
.nodes {
   list-style: none;
   padding-left: 0;
   margin-top: 0.5em;
}
.pds-node {
   cursor: pointer;
   list-style: none;
   text-align: center;
   background-color: #c2c2f0;
   margin-right: 10px;
   width: 125px;
   line-height: 30px;
   margin-bottom: 5px;
   display: inline-block;

   &.active {
      color: #fff;
      background-color: #25258e;
      font-weight: bold;
   }
}
@media screen and (min-width: 1200px) {
   .nodes-container {
      padding-top: 0;
   }
   .nodes {
      li { /*display: inline-block;*/ float:left; }
   }
}
</style>

